let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3u49T")).then(() => parcelRequire('b6so3'));